import { roles } from 'common-src/models/Client/constants';
import { mapObject } from 'common-src/utils/objectUtils';

export const SUPER_ADMIN_ORG_ID = 1;

export const OrganizationAccessRoles = mapObject(roles, ([key, value]) => [key, value.id]);
